export const CUSTODIAL_CASH_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' }
]

export const PAGE_SIZE_OPTIONS = [50, 100, 250, 500]

export const DEFAULT_PAGE_SIZE = 50

export const DEFAULT_QUICK_DATES = [
  'Day', 'WTD', 'MTD', 'QTD', 'YTD',
  'One Year', 'Two Year', 'Three Year', 'Four Year', 'Five Year',
  'Six Year', 'Seven Year', 'Eight Year', 'Nine Year', 'Ten Year',
  'Previous 1-Year', 'Previous 2-Year', 'Previous 3-Year', 'Previous 5-Year',
  'Custom'
]

export const DEFAULT_METRIC_GROUPS = [
  {
    id: 'buys-sells',
    title: 'Buys & Sells',
    financialTypes: [3, 4],
    metrics: [
      { label: 'Total', op: 'count', format: 'number' },
      { label: 'Notional Amt', op: 'sum', format: 'currency' }
    ]
  },
  {
    id: 'flows',
    title: 'Flows',
    financialTypes: [1, 2],
    metrics: [
      { label: 'Total', op: 'count', format: 'number' },
      { label: 'Notional Amt', op: 'sum', format: 'currency' }
    ]
  },
  {
    id: 'div-interest',
    title: 'Dividend & Interest',
    financialTypes: [5, 7],
    metrics: [
      { label: 'Total', op: 'count', format: 'number' },
      { label: 'Notional Amt', op: 'sum', format: 'currency' }
    ]
  }
]

export const MANAGED_FILTER_OPTIONS = [
  { value: 'all', label: 'All Assets' },
  { value: 'managed', label: 'Managed Only' },
  { value: 'unmanaged', label: 'Unmanaged Only' }
]

export const METRIC_OP_OPTIONS = [
  { value: 'count', label: 'Count' },
  { value: 'sum', label: 'Sum' },
  { value: 'avg', label: 'Average' },
  { value: 'min', label: 'Min' },
  { value: 'max', label: 'Max' }
]

export const EMPTY_HIERARCHY_QUERY = {}

export const INCOME_FINANCIAL_TYPE = 7
export const DIVIDEND_REINVESTMENT_TRANSTYPES = [14, 174]

export const DEFAULT_RULES = {
  excludeCustodialCashBuySell: true,
  managedFilter: 'managed'
}

export const DEFAULT_CONFIG = {
  defaultQuickDate: 'YTD',
  availableQuickDates: DEFAULT_QUICK_DATES,
  availableFilters: {
    transactionTypes: true,
    iscustodialcash: true,
    transamount: true,
    managedFilter: false
  },
  defaultSort: { field: 'transdate', dir: 'desc' },
  defaultPageSize: DEFAULT_PAGE_SIZE,
  columns: null,
  localStorageKey: null,
  showExport: true,
  showColumnConfig: true,
  showMetrics: true,
  metricLayout: 'stretch',
  metricGroups: DEFAULT_METRIC_GROUPS,
  rules: DEFAULT_RULES,
  detailView: 'modal',
  tableStyleVariant: 'default',
  tableStyleVariantParams: {},
  styleVariant: 'default',
  scopeType: 'client'
}
